import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

export interface JsmInstance {
  id: string;
  name: string;
  url: string;
}

export interface JsmCredential {
  id: string;
  jsmInstanceId: string;
  scopes: Record<string, boolean>;
  createdAt: string;
  updatedAt: string;
  jsmInstance: JsmInstance | null;
}

export interface JsmServiceDesk {
  id: string;
  projectId: string;
  projectName: string;
  projectKey: string;
  projectTypeKey: string;
}

export interface JsmRequestType {
  id: string;
  name: string;
  description: string;
  issueTypeId: string;
}

@Injectable({
  providedIn: 'root',
})
export class JsmService {
  constructor(private apiService: ApiService) {}

  async getConnectedCredentials(): Promise<JsmCredential[]> {
    return await this.apiService.getPromise<JsmCredential[]>('/jsm/credentials');
  }

  async getAllServiceDesks(jsmInstanceId: string): Promise<JsmServiceDesk[]> {
    return await this.apiService.getPromise<JsmServiceDesk[]>(`/jsm/instances/${jsmInstanceId}/service-desks`);
  }

  async getAllRequestTypes(jsmInstanceId: string, jsmServiceDeskId: string): Promise<JsmRequestType[]> {
    return await this.apiService.getPromise<JsmRequestType[]>(
      `/jsm/instances/${jsmInstanceId}/service-desks/${jsmServiceDeskId}/request-types`,
    );
  }

  async bulkCreateChannels(
    projectId: string,
    credentialId: string,
    jsmInstanceId: string,
    serviceDesks: { id: string; name: string }[],
  ): Promise<{
    success: boolean;
    created: number;
    failed: number;
    results: any[];
    errors: any[];
  }> {
    return await this.apiService.postPromise('/jsm/channels/bulk', {
      projectId,
      credentialId,
      jsmInstanceId,
      serviceDesks,
    });
  }
}
